import { createPutEndpoint } from '@sonar-software/sonar-http';

export type PutJiraCredentialsRequest = {
	apiToken: string;
	customerId: number;
	url: string;
	username: string;
};

export const putJiraCredentials = createPutEndpoint<PutJiraCredentialsRequest>('/api/v3/jira/credentials');
